import { Box } from "@mui/material"
import { Outlet } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import Header from "./header/Header"
import Footer from "./footer/Footer"
import BarMenu from "./navbar/BarMenu"
import useForegroundMessages from "../hooks/useForegroundMessages"
import { useThemeMode } from "../contexts/ThemeContext"
import { syncTheme } from "../utils/themedToast"

export default function Layout() {
    const { auth } = useAuth()
    const { theme, scheme } = useThemeMode()
    syncTheme(theme, scheme)
    useForegroundMessages()
    return (
        <Box
            sx={{
                position: "relative",
                minHeight: "100vh",
                backgroundColor: "transparent",
            }}
        >
            <Box
                sx={
                    {
                        // pb: "5rem",
                    }
                }
            >
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        top: 0,
                        left: 0,
                        right: 0,
                    }}
                >
                    <Header />
                </Box>
                <Box
                    sx={{
                        zIndex: 2,
                        width: "100%",
                    }}
                >
                    {auth?.token && <BarMenu />}
                    <Outlet />
                </Box>
            </Box>
            <Footer />
        </Box>
    )
}
